import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function ConfiguratorCTA() {
  const openConfigurator = () =>
    window.open("https://konfigurator.cool-pool-company.de/", "_blank", "noopener");

  return (
    <section id="konfigurator" data-testid="configurator-redirect-section" className="relative py-20 sm:py-28 bg-[#07101D] overflow-hidden">
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/9119784/pexels-photo-9119784.jpeg?auto=compress&cs=tinysrgb&w=1800')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#07101D] via-[#07101D]/70 to-[#07101D]" aria-hidden="true" />

      <div className="relative max-w-3xl mx-auto px-5 sm:px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="text-xs uppercase tracking-[0.32em] font-mono text-cyan-400 font-semibold"
        >
          Pool-Konfigurator
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-4 font-medium tracking-tight leading-tight text-3xl sm:text-5xl text-white"
        >
          Ihr Traumpool beginnt <span className="italic text-cyan-300">hier.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-5 text-slate-300 text-sm sm:text-base font-light max-w-xl mx-auto"
        >
          Stellen Sie in wenigen Schritten Ihren Wunschpool zusammen — direkt in unserem Online-Konfigurator.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <button
            data-testid="configurator-external-link-button"
            onClick={openConfigurator}
            className="mt-9 cyan-glow-btn text-[#050B14] font-semibold px-8 py-4 rounded-full inline-flex items-center gap-2 text-sm sm:text-base"
          >
            Zum Pool-Konfigurator <ArrowUpRight className="w-4 h-4" />
          </button>
          <p className="mt-4 text-xs font-mono text-slate-500">konfigurator.cool-pool-company.de</p>
        </motion.div>
      </div>
    </section>
  );
}
